import type { FC } from "react";

import { QuickLinks as QuickLinksUI, QuickLinksGroup } from "@jti/ui/components/QuickLinks";

import type { quickLinksInputs } from "./QuickLinks.builder";

export type QuickLinksProps = BuilderComponentProps<typeof quickLinksInputs>;

export const QuickLinks: FC<QuickLinksProps> = ({ groups = [] }) => {
  return (
    <QuickLinksUI>
      {groups.map(({ title, categories }, index) => (
        <QuickLinksGroup key={index} title={title} categories={categories} />
      ))}
    </QuickLinksUI>
  );
};
